import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69d91d38a749570014996a2b/blv/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69d91d38a749570014996a2b/blv/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69d91d38a749570014996a2b/blv/src/app/landing-welcome/components/LandingHero.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69d91d38a749570014996a2b/blv/src/components/ui/AppLogo.tsx");
